export const SOCIALS_CONFIG = {
  linkedin: "https://www.linkedin.com/company/darvindotdev/",
  x: "https://x.com/darvin_dev",
  medium: "https://medium.com/@darvin.dev",
};
